export const HEADER_NAV_HEIGHT = {
  mobile: 60,
  desktop: 72,
  responsive: ['4.1875rem', null, null, '5rem'],
};
